"use client";

import {Box, Text, Stack, TextProps} from "@chakra-ui/react";
import {Container} from "../../components/Container";
import Footer from "../../components/Footer";
import {Header} from "../../components/Header";
import Heading from "../../components/Heading";
import ContactUs from "./ContactUs";
import {HeroContainer} from "../../components/Hero";
import {useEffect} from "react";

export const HeadingEm = (props: TextProps) => (
  <Text as="em" color="white" display="inline" fontStyle="unset" {...props} />
);

const DEFAULT_HERO_HEADING = (
  <>
    Equip Your Auditors With <HeadingEm>AI Superpowers</HeadingEm>
  </>
);
const DEFAULT_HERO_SUBHEADING = (
  <>
    Is your firm ready to reduce audit cost by 66% while increasing audit revenue with AI? Get in touch with our team
    today
  </>
);
const DEFAULT_EMAIL_TEXT = (
  <>
    Interested in learning more but not quite ready for a demo? Get in touch with our team, and we&apos;ll answer any of
    your burning questions
  </>
);

const Hero = ({heading, subheading}: {heading: React.ReactNode; subheading: React.ReactNode}) => (
  <Box bgGradient="blue" overflowX="hidden">
    <HeroContainer>
      <Stack textAlign={["left", "left", "center"]} gap={6} alignItems="center" flex={1} justifyContent="center">
        <Heading
          w="full"
          fontSize={["4xl", "4xl", "5xl"]}
          fontWeight="display"
          color="blue.100"
          letterSpacing="tight"
          textShadow="0px 1px 5px rgba(0,0,0,.1)"
          lineHeight={1.2}
        >
          {heading}
        </Heading>
        <Text fontSize={["lg", "xl"]} color="blue.100" w="full" maxW="52rem">
          {subheading}
        </Text>
      </Stack>
    </HeroContainer>
  </Box>
);

export const Contact = ({
  heroHeading = DEFAULT_HERO_HEADING,
  heroSubheading = DEFAULT_HERO_SUBHEADING,
  emailText = DEFAULT_EMAIL_TEXT,
}: {
  heroHeading?: React.ReactNode;
  heroSubheading?: React.ReactNode;
  emailText?: React.ReactNode;
}) => (
  <>
    <Header />
    <Box as="main" flex={1}>
      <Hero heading={heroHeading} subheading={heroSubheading} />
      <ContactUs emailText={emailText} />
    </Box>
    <Footer />
  </>
);

export const ThankYou = ({
  heroHeading = DEFAULT_HERO_HEADING,
  heroSubheading = DEFAULT_HERO_SUBHEADING,
}: {
  heroHeading?: React.ReactNode;
  heroSubheading?: React.ReactNode;
}) => {
  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-16783376035/nrfmCKPMiOwZEKP998I-",
        value: 1.0,
        currency: "GBP",
      });
    }
  });

  return (
    <Stack gap={0} minH="100vh">
      <Header />
      <Box as="main" flex={1}>
        <Hero heading={heroHeading} subheading={heroSubheading} />
        <Container py={[28, 32]} textAlign="center">
          <Stack gap={8}>
            <Heading>Thank you!</Heading>
            <Text color="gray.700">We&apos;ll be in touch soon.</Text>
          </Stack>
        </Container>
      </Box>
      <Footer />
    </Stack>
  );
};
